import { faBoxOpen } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Box, Typography } from "@mui/material";

function NoItemsCard() {
    return (
        <Box
            sx={{
                p: 2,
                textAlign: "center",
                border: "1px dashed",
                borderColor: "#585757",
                borderRadius: 2,
                marginTop:1,
                backgroundColor: "background.default",
            }}
        >
            <Box
                sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    gap: 1.5,
                }}
            >
                <Box
                    sx={{
                        width: 20,
                        height: 10,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        borderRadius: "50%",
                        backgroundColor: "action.hover",
                        color: "text.disabled",
                    }}
                >
                    <FontAwesomeIcon
                        icon={faBoxOpen}
                        style={{ fontSize: 26 }}
                    />
                </Box>

                <Typography
                    variant="h6"
                    color="text.secondary"
                    fontWeight={600}
                    sx={{
                        fontSize:14
                    }}
                >
                   ADD ITEM 
                </Typography>

                <Typography
                    variant="body2"
                    color="text.secondary"
                    sx={{
                        padding:0,
                        margin:0,
                        textTransform:"uppercase",
                        fontSize:10
                    }}
                >
                   At least one item must be added.
                </Typography>
            </Box>
        </Box>
    );
}

export default NoItemsCard;

